import { filter, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { selectLotRoutingOutcome } from './selectors';

/**
 * Reacts to lotSelected: looks up the routing outcome for the clicked lot and dispatches
 * navigateTo when one exists. A wrong-status lot, or one with neither multiple plans nor a
 * housing unit, is a no-op — and so, for now, is every desktop single-result lot (single plan,
 * or a housing unit already built), since VIEW_FLOOR_PLAN_DETAIL/VIEW_HOUSING_UNIT_DETAIL are
 * still blank scaffolds with no content to route into (see selectLotRoutingOutcome). A lot
 * outside the active chip never reaches here at all; lotInteraction.plugin.js's onLotSelected
 * blocks that click before lotSelected is dispatched.
 *
 * @param {object} params
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @param {boolean} params.isMobile - device flag, captured once at epic-creation time (same
 *   signal drawer.plugin.js / cardLotHighlight.plugin.js already gate themselves on) and passed
 *   straight through to selectLotRoutingOutcome on every lot click.
 * @returns {import('redux-observable').Epic}
 */
function createLotSelectedEpic({ dataActions, isMobile }) {
  return (action$, state$) => action$.pipe(
    ofType(dataActions.lotSelected.type),
    map(({ payload: lotId }) => selectLotRoutingOutcome(state$.value, lotId, isMobile)),
    filter(Boolean),
    map((outcome) => dataActions.navigateTo(outcome)),
  );
}

export default createLotSelectedEpic;
